import { Highlight, Text } from '@mantine/core';
import React from 'react';
import { useOrganisationSearch } from '../../context/OrganisationSearchContext';
import arrow from '../../assets/arrow.svg';
import { ProcurementManagerCategory } from '../../codegen/graphql';

type Props = {
    category: ProcurementManagerCategory;
};

function ProductCategoryCard({ category }: Props) {
    const { organisationSearch } = useOrganisationSearch();

    return (
        <div
            style={{
                borderLeft: `4px solid #7EACFA`,
            }}
            className="flex relative bg-white h-16 ml-[22px] px-3 items-center"
        >
            <img
                src={arrow}
                alt="L-arrow"
                className="w-6 absolute h-24 -top-11 -left-[28px]"
            />
            <div className="grid grid-rows-1 grid-cols-24 gap-6 items-center w-full">
                <Text className="font-bold col-span-6">
                    <Highlight highlight={organisationSearch}>
                        {category.name ?? ''}
                    </Highlight>
                </Text>
                <Text
                    size="sm"
                    className="col-span-5 whitespace-nowrap text-ellipsis overflow-hidden text-sm"
                >
                    {category.productCount} product
                    {category.productCount > 1 && 's'}
                </Text>
                <Text className="col-span-4 whitespace-nowrap text-ellipsis overflow-hidden text-sm">
                    Margin:{' '}
                    <span className="font-semibold">
                        {category.benchmarkMargin}%
                    </span>
                </Text>
                <div />
            </div>
        </div>
    );
}

export default ProductCategoryCard;
